import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import GitHubIcon from "../../img/github-icon.svg";
import LinkedInIcon from "../../img/linkedin-icon.svg";
import "./SocialMediaCarousel.css";

import { useTheme } from "../../context/ThemeContext";

interface SocialMediaCarouselProps {}

export const SocialMediaCarousel = ({ ...props }: SocialMediaCarouselProps) => {
  const { activeTheme } = useTheme();

  return (
    <>
      <Carousel
        showArrows={false}
        autoPlay={true}
        infiniteLoop={true}
        swipeable={true}
        emulateTouch={true}
        showStatus={false}
        showIndicators={false}
        thumbWidth={100}
        width={"100%"}
      >
        {/* Carousel Slide 2 */}
        <div
          className={
            activeTheme === "light"
              ? "social-media-carousel-slide-light-theme"
              : "social-media-carousel-slide-dark-theme"
          }
        >
          <img
            className="social-media-carousel-slide-logo"
            src={LinkedInIcon}
            alt="LinkedIn"
          />
          <div className="social-media-carousel-slide-content">
            <h1>LinkedIn</h1>

            <p>
              Lets connect and grow our networks. Business and personal
              connections open up so many career doors.
            </p>
            <a
              href="https://www.linkedin.com/in/jay0311/"
              rel="noopener noreferrer"
              target="_blank"
              className={
                activeTheme === "light"
                  ? "carousel-button-light-theme"
                  : "carousel-button-dark-theme"
              }
            >
              View Profile
            </a>
          </div>
          <div className="social-media-carousel-slide-graphic">
            <svg
              width="100"
              height="100"
              viewBox="0 0 171 171"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M138.937 32.0625C133.188 37.5666 126.273 41.895 118.61 44.6524C110.616 46.0631 88.4925 35.8031 77.5912 46.2769C75.7744 48.0938 73.53 49.9106 71.1787 51.7275C66.0487 49.4831 58.14 46.0631 52.3687 42.75C46.5975 39.4369 32.0625 32.0625 32.0625 32.0625L0 69.4688C0 69.4688 7.90875 80.1562 12.825 87.21C16.0312 91.9125 19.9856 99.0731 22.5506 103.882L18.9169 108.158C18.297 109.387 17.9229 110.829 17.9229 112.358C17.9229 114.869 18.9062 117.156 20.52 118.845C21.9949 119.946 23.8438 120.608 25.8637 120.608C27.8837 120.608 29.7326 119.946 31.2289 118.824C30.2242 119.989 29.6364 121.485 29.6364 123.12C29.6364 125.183 30.5769 127.021 32.0518 128.239C33.5908 129.148 35.4397 129.682 37.4062 129.682C39.3727 129.682 41.2217 129.148 42.8034 128.218C41.6064 129.703 40.9117 131.563 40.9117 133.594C40.9117 135.624 41.6064 137.484 42.7714 138.959C43.8294 139.333 45.0585 139.557 46.341 139.557C48.5533 139.557 50.6053 138.884 52.3046 137.74C51.8451 138.756 51.6099 139.91 51.6099 141.128C51.6099 143.629 52.6359 145.884 54.3032 147.488C55.6926 148.118 57.3277 148.481 59.0377 148.481C61.4531 148.481 63.7082 147.755 65.5678 146.504L71.0826 141.513C76.1271 146.536 83.0846 149.646 90.7689 149.646C90.9827 149.646 91.2071 149.646 91.4209 149.636C96.7005 149.187 101.125 145.831 103.113 141.182C104.673 141.78 106.447 142.187 108.328 142.187C110.851 142.187 113.191 141.46 115.168 140.209C121.421 136.073 119.924 132.867 119.924 132.867C121.26 133.455 122.81 133.797 124.445 133.797C127.876 133.797 130.965 132.279 133.059 129.885C134.94 127.951 136.084 125.322 136.084 122.436C136.084 120.405 135.517 118.514 134.534 116.9C134.62 116.953 134.695 116.953 134.759 116.953C139.258 116.953 143.17 114.474 145.211 110.819C145.938 108.991 146.333 106.939 146.333 104.802C146.333 101.146 145.158 97.7586 143.17 95.0012L143.202 95.0546C151.966 93.3446 151.645 88.9627 155.92 82.5503C160.024 77.2706 165.026 72.9101 170.743 69.6397L138.937 32.0625ZM138.403 107.516C133.701 112.219 130.067 110.188 122.051 104.096C114.036 98.0044 98.1112 86.5688 98.1112 86.5688C98.7632 89.8284 100.27 92.6606 102.397 94.9157C105.806 98.7525 115.959 107.516 120.769 112.005C123.761 114.784 131.456 120.341 126.967 124.616C122.479 128.891 118.952 124.616 111.577 118.631C104.203 112.646 87.7444 97.8975 87.7444 97.8975C87.7337 98.0899 87.723 98.3036 87.723 98.5281C87.723 101.285 88.8345 103.776 90.63 105.592C92.4469 107.73 102.6 117.562 106.875 122.051C111.15 126.54 114.891 129.212 111.257 132.739C107.623 136.266 100.249 130.708 96.1875 126.54C89.8819 120.448 77.3775 109.119 77.3775 109.119C77.3668 109.29 77.3668 109.483 77.3668 109.686C77.3668 112.721 78.4142 115.5 80.1776 117.701C83.2556 121.741 89.2406 126.978 92.8744 131.039C96.5081 135.101 98.6456 138.521 92.8744 141.727C87.1031 144.933 78.5531 137.024 74.8125 133.177C74.8125 133.166 74.8125 133.166 74.8125 133.156C74.8125 132.055 74.4064 131.05 73.7437 130.281C72.0444 128.71 69.7466 127.737 67.2351 127.737C66.1236 127.737 65.0548 127.929 64.0609 128.271C65.4289 127.053 66.2411 125.343 66.2411 123.441C66.2411 121.538 65.4289 119.828 64.125 118.631C62.7784 117.616 61.0897 117.007 59.2622 117.007C57.4346 117.007 55.7353 117.616 54.378 118.642C55.6284 117.434 56.3979 115.778 56.3979 113.929C56.3979 111.652 55.233 109.654 53.4696 108.489C51.8344 107.452 49.8786 106.854 47.7838 106.854C45.1761 106.854 42.7821 107.794 40.9224 109.344C41.9377 108.125 42.5362 106.565 42.5362 104.855C42.5362 102.771 41.6278 100.901 40.1957 99.6075C38.2933 97.8441 35.739 96.7646 32.9389 96.7646C30.9617 96.7646 29.1127 97.299 27.5203 98.2395L20.4131 86.2374C15.4969 78.4356 9.72562 70.3131 9.72562 70.3131L34.0931 40.7087C34.0931 40.7087 42.75 46.0524 49.9106 50.1137C53.4375 52.1443 59.5294 54.8162 64.125 56.9537C56.8575 62.4043 50.7656 67.6412 52.5825 71.2749C55.7567 73.5621 59.7217 74.9408 64.0074 74.9408C68.0259 74.9408 71.7666 73.7331 74.8873 71.6597C78.8737 68.9771 83.8648 67.3526 89.2406 67.3526C92.9492 67.3526 96.4761 68.1221 99.6716 69.5222C105.592 73.5193 116.494 83.3518 126.433 89.5506C138.937 98.6349 141.396 104.513 138.403 107.506V107.516Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        {/* Carousel Slide 2 */}

        {/* Carousel Slide 8 */}
        <div
          className={
            activeTheme === "light"
              ? "social-media-carousel-slide-light-theme"
              : "social-media-carousel-slide-dark-theme"
          }
        >
          <img
            className="social-media-carousel-slide-logo"
            src={GitHubIcon}
            alt="GitHub"
          />
          <div className="social-media-carousel-slide-content">
            <h1>GitHub</h1>

            <p>
              GitHub is the place where I store all of my programming related
              projects. It is an online repository where us developers store our
              codebases. Check out my projects.
            </p>
            <a
              href="https://github.com/jaypatel0311"
              rel="noopener noreferrer"
              target="_blank"
              className={
                activeTheme === "light"
                  ? "carousel-button-light-theme"
                  : "carousel-button-dark-theme"
              }
            >
              View Profile
            </a>
          </div>
          <div className="social-media-carousel-slide-graphic">
            <svg
              width="100"
              height="100"
              viewBox="0 0 171 171"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M96.957 114C95.3839 114 94.1212 115.277 94.1212 116.85C94.1212 118.423 95.4123 119.7 96.9854 119.7C98.5615 119.7 99.8353 118.423 99.8353 116.85C99.8353 115.277 98.5615 114 96.9854 114H96.957Z"
                fill="#EDF2FA"
              />
              <path
                d="M105.45 79.7999C103.891 79.7999 102.64 81.054 102.62 82.6127C102.6 84.1745 103.856 85.46 105.415 85.4997C106.732 85.5338 108.3 86.0555 108.3 88.3496V91.1995C108.3 92.2909 108.434 100.328 112.25 105.216C108.354 108.938 108.3 113.751 108.3 114V122.55C108.3 124.841 106.735 125.365 105.421 125.399C103.859 125.414 102.6 126.685 102.6 128.249C102.6 129.822 103.876 131.099 105.45 131.099C108.887 131.099 114 128.822 114 122.549V113.999C114 113.959 114.048 110.038 118.124 108C119.09 107.515 119.7 106.529 119.7 105.449C119.7 104.369 119.09 103.383 118.124 102.899C115.029 101.354 114.008 94.3456 114 91.1995V88.3496C114 82.077 108.887 79.7999 105.45 79.7999Z"
                fill="#EDF2FA"
              />
              <path
                d="M156.75 39.9001H128.25C123.536 39.9001 119.7 36.064 119.7 31.3501V17.1C119.7 15.5269 118.423 14.2501 116.85 14.2501C115.277 14.2501 114 15.5269 114 17.1V31.3501C114 39.2074 120.393 45.6002 128.25 45.6002H153.9V156.75C153.9 161.464 150.064 165.3 145.35 165.3H25.65C20.9362 165.3 17.1 161.464 17.1 156.75V14.2501C17.1 9.53626 20.9362 5.70011 25.65 5.70011H115.67L143.335 33.365C144.45 34.4795 146.251 34.4795 147.365 33.365C148.479 32.2509 148.479 30.4494 147.365 29.3352L118.865 0.834961C118.332 0.29925 117.605 0 116.85 0H25.65C17.7927 0 11.3999 6.39246 11.3999 14.2501V156.75C11.3999 164.608 17.7927 171 25.65 171H145.35C153.207 171 159.6 164.608 159.6 156.75V42.75C159.6 41.1769 158.323 39.9001 156.75 39.9001Z"
                fill="#EDF2FA"
              />
              <path
                d="M65.5785 85.5001C67.1402 85.4857 68.4 84.2146 68.4 82.6502C68.4 81.0771 67.1232 79.8003 65.5501 79.8003C62.1131 79.8003 57.0001 82.0774 57.0001 88.3503L57.9149 89.1084C57.3535 89.6271 57.0001 90.3709 57.0001 91.2002C57.0001 94.3466 55.9912 101.343 52.8761 102.899C51.9099 103.384 51.3 104.37 51.3 105.45C51.3 106.53 51.9099 107.516 52.8761 108.001C56.8575 109.99 56.9971 113.869 57.0001 114V122.55C57.0001 128.823 62.1131 131.1 65.5501 131.1C67.1092 131.1 68.3603 129.846 68.3803 128.287C68.4003 126.725 67.1436 125.44 65.5845 125.4C64.268 125.366 62.7002 124.844 62.7002 122.55V114C62.7002 113.752 62.6461 108.939 58.7502 105.216C61.6659 101.483 62.4324 95.914 62.6318 93.0044L62.7002 93.0615V91.2005C62.7002 90.3712 62.3469 89.6274 61.7855 89.1088L62.7002 88.3506C62.6999 86.0588 64.2646 85.5341 65.5785 85.5001Z"
                fill="#EDF2FA"
              />
              <path
                d="M85.5571 114C83.984 114 82.7213 115.277 82.7213 116.85C82.7213 118.423 84.0124 119.7 85.5855 119.7C87.1586 119.7 88.4354 118.423 88.4354 116.85C88.4354 115.277 87.1586 114 85.5855 114H85.5571Z"
                fill="#EDF2FA"
              />
              <path
                d="M74.1569 114C72.5838 114 71.321 115.277 71.321 116.85C71.321 118.423 72.6122 119.7 74.1853 119.7C75.7584 119.7 77.0352 118.423 77.0352 116.85C77.0352 115.277 75.7584 114 74.1853 114H74.1569Z"
                fill="#EDF2FA"
              />
            </svg>
          </div>
        </div>
        {/* Carousel Slide 8 */}
      </Carousel>
    </>
  );
};

export default SocialMediaCarousel;
